import $ from "jquery"
import './../scss/style.scss';

// svgstore
window.baseUrl = '/local/dist/';
var __svg__ = { path: './../svg/**/*.svg', name: 'sprite.svg' };
require('webpack-svgstore-plugin/src/helpers/svgxhr')(__svg__);
//  import Bootstrap 
require('bootstrap');

import { WCAG } from "rytm-wcag";
import { initCommon } from './shared/common'
import { initCookies } from './shared/cookies'
import { loadingSequence } from "./loading";
import { initWfHeader } from "./wf/wf-header";


$(() => {
  // # on ready
  initCommon()
  initCookies()
  initWfHeader()
  WCAG.init()
  // loading sequence
  loadingSequence()
});

$(window).on( "load", ()=> {
  // # on load
});